import { render, staticRenderFns } from "./LinkToItineraryAlert.vue?vue&type=template&id=331b7bcd&"
import script from "./LinkToItineraryAlert.vue?vue&type=script&lang=js&"
export * from "./LinkToItineraryAlert.vue?vue&type=script&lang=js&"
import style0 from "./LinkToItineraryAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports